import {
  Modal,
  ModalBody,
  ModalFooterDefault,
  ModalHeaderDefault,
} from 'ui-components';

import { CreatorProfileSettingsForm } from './CreatorProfileSettingsForm';
import { useProfileSettingsModalStore } from './useProfileSettingsModal';

export const CreatorProfileSettingsModal = () => {
  const { isOpen, closeModal, onSuccessCallback } =
    useProfileSettingsModalStore();

  const handleSuccess = async () => {
    if (onSuccessCallback) {
      await onSuccessCallback();
    }
    closeModal();
  };

  return (
    <Modal isOpen={isOpen} onClose={closeModal} size="lg">
      <ModalHeaderDefault title="Your profile information" />
      <ModalBody>
        <p className="mb-4 text-14 text-root-text-color-base">
          This information helps brands understand who you are. This will be
          used across all your Media Kits and can be updated anytime in your
          Profile Settings.
        </p>
        <CreatorProfileSettingsForm
          showTitle={false}
          showActionButtons={false}
          showLeavePageBoundary={false}
          onSuccess={handleSuccess}
          onCancel={closeModal}
          renderCustomActions={({
            dirty,
            isLoading,
            resetForm,
            submitForm,
          }) => (
            <ModalFooterDefault
              secondary={{
                title: 'Cancel',
                onClick: () => {
                  resetForm();
                  closeModal();
                },
                isDisabled: isLoading,
                trackId: 'foam-profile-settings-modal-cancel',
              }}
              primary={{
                title: 'Save',
                onClick: submitForm,
                isDisabled: isLoading || !dirty,
                isLoading: isLoading,
                trackId: 'foam-profile-settings-modal-save',
              }}
            />
          )}
        />
      </ModalBody>
    </Modal>
  );
};
